import type { Field, Hierarchies, HierarchyType } from "@/entities/form-metadata";
import type { IdHierarchy } from "@/entities/place";
import { HierarchicSelect } from "./HierarchicSelect";
import { useHierarchicalFieldControls } from "./useHierarchicalFieldControls";
import { useHierarchyInitialize } from "./useHierarchyInitialize";

interface HierarchyLevelItemProps {
    field: Field<HierarchyType>;
    hierarchy: Hierarchies;
    locationLevels: IdHierarchy | null;
    testId: string;
    upperValue?: { locationName: string; gpid: number } | null;
    isLeaf?: boolean;
}

export const HierarchyLevelItem = ({
    field,
    hierarchy,
    locationLevels,
    testId,
    upperValue = null,
    isLeaf = false,
}: HierarchyLevelItemProps) => {
    const { currentLevelValue, leaf, onChangeFilter } = useHierarchicalFieldControls({
        field,
        hierarchy,
        isLeaf,
        upperValue,
    });

    const { initialGpidForCurrentLevel } = useHierarchyInitialize({
        field,
        isLeaf,
        locationLevels,
        onChangeFilter,
    });

    const renderSubItems = () => {
        if (!leaf?.hierarchies[0]?.fields) return null;

        return leaf.hierarchies[0].fields.map((subField, index, array) => (
            <HierarchyLevelItem
                key={subField.label}
                field={subField}
                hierarchy={leaf.hierarchies[0] as Hierarchies}
                locationLevels={locationLevels}
                upperValue={currentLevelValue}
                isLeaf={index === array.length - 1}
                testId={testId}
            />
        ));
    };

    return (
        <>
            <HierarchicSelect
                value={initialGpidForCurrentLevel}
                field={field}
                testId={`hierarchy-${isLeaf ? "leaf" : "root"}-${testId}`}
                onChangeFilter={onChangeFilter}
            />
            {renderSubItems()}
        </>
    );
};
